import { auth } from './auth'
import { generateUUID } from '../uuid-generator'
import {
    setAuthBusy,
    setAuthError,
} from '../../../reducers/actions/auth'
import { database } from '../database'

/**
 * Login
 *
 * @param {string} email
 * @param {string} password
 * @return {Promise}
 */
export const login = (email, password) => {
    if (!email || !password || email === '' || password === '') {
        setAuthError('auth/fill-all')

        throw new Error()
    }

    setAuthBusy(true)

    return auth().signInWithEmailAndPassword(email, password)
        .catch(err => {
            setAuthError(err.code)
            setAuthBusy(false)
            throw new Error(err.code)
        })
        .then(() => {
            setAuthBusy(false)
            const currentUser = auth().currentUser

            database('user')
                .doc(currentUser.uid)
                .update({
                    userToken: generateUUID(),
                })

            return new Promise(resolve => resolve(currentUser))
        })
}
